import { Heart } from "lucide-react";

const particles = [
  "-translate-x-5 -translate-y-10 rotate-[-18deg]",
  "translate-x-0 -translate-y-12 rotate-[10deg]",
  "translate-x-5 -translate-y-9 rotate-[20deg]",
  "-translate-x-2 -translate-y-7 rotate-[-8deg]",
];

export const HeartBurst = ({ active }) => {
  if (!active) return null;

  return (
    <span className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center">
      {particles.map((position, index) => (
        <Heart
          key={position}
          size={index === 1 ? 13 : 11}
          fill="currentColor"
          className={`absolute text-red-500 opacity-0 animate-[heart-float_700ms_ease-out_forwards] ${position}`}
          style={{ animationDelay: `${index * 55}ms` }}
        />
      ))}
    </span>
  );
};

export default HeartBurst;
